/**
 * mue.ts — Categoría "Muebles" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_mue",
  skuPrefix: "MUE",
  categoria: "Muebles",
} as const;

export const cat_mue_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Sofá 3 Puestos Moderno",
    marca: "Jamar",
    modelo: "Toscana",
    origen: "Colombia",
    costo: 985000,
    precio: 1499000,
    stock: 8,
    stockMinimo: 2,
    stockMaximo: 16,
    unidad: "unidad",
    ubicacionFisica: "Showroom M1",
    proveedor: "Jamar S.A.",
    garantia: "2 años",
    tiempoEntrega: "10 días",
    material: "Madera, espuma alta densidad, tela chenille",
    colorProducto: "Gris claro",
    dimensiones: "220x90x85cm",
    descripcionLarga:
      "Sofá 3 puestos estructura en madera certificada, cojines espuma HR, tela chenille antimanchas. Diseño contemporáneo.",
    especificaciones: [
      { clave: "Capacidad", valor: "3 personas" },
      { clave: "Profundidad", valor: "90cm" },
    ],
    imageKeywords: ["sofa", "modern-sofa", "living-room-couch"],
    color: "bg-slate-400",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Mesa Comedor 6 Puestos",
    marca: "Homecenter",
    modelo: "Escandinava",
    origen: "Colombia",
    costo: 685000,
    precio: 1049000,
    stock: 6,
    stockMinimo: 2,
    stockMaximo: 12,
    unidad: "unidad",
    ubicacionFisica: "Showroom M1",
    proveedor: "Sodimac Colombia",
    garantia: "1 año",
    tiempoEntrega: "7 días",
    material: "MDF laminado roble",
    colorProducto: "Roble natural",
    dimensiones: "160x90x75cm",
    descripcionLarga:
      "Mesa de comedor rectangular para 6 personas, estilo escandinavo. MDF con lámina roble resistente. Patas tornillo.",
    especificaciones: [
      { clave: "Capacidad", valor: "6 personas" },
      { clave: "Material", valor: "MDF" },
    ],
    imageKeywords: ["dining-table", "wooden-table", "scandinavian-table"],
    color: "bg-amber-600",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Silla Oficina Ergonómica",
    marca: "Herman Miller",
    modelo: "Aeron Size B",
    origen: "EE.UU.",
    costo: 2850000,
    precio: 4390000,
    stock: 5,
    stockMinimo: 2,
    stockMaximo: 10,
    unidad: "unidad",
    ubicacionFisica: "Showroom M2",
    proveedor: "Herman Miller LATAM",
    garantia: "12 años",
    tiempoEntrega: "15 días",
    material: "Malla PelliKon, aluminio",
    colorProducto: "Negro grafito",
    descripcionLarga:
      "Silla ergonómica premium con soporte lumbar PostureFit SL, malla 8Z Pellicle transpirable. Icono del diseño.",
    especificaciones: [
      { clave: "Tamaño", valor: "B (mediano)" },
      { clave: "Peso máx", valor: "159kg" },
    ],
    imageKeywords: ["office-chair", "ergonomic-chair", "herman-miller"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "ambicioso",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Cama Queen con Base",
    marca: "Paraíso",
    modelo: "Tempur-Cloud Queen",
    origen: "Colombia",
    costo: 1250000,
    precio: 1899000,
    stock: 6,
    stockMinimo: 2,
    stockMaximo: 12,
    unidad: "unidad",
    ubicacionFisica: "Showroom M3",
    proveedor: "Colchones Paraíso",
    garantia: "10 años",
    tiempoEntrega: "10 días",
    material: "Madera, resortes + espuma",
    colorProducto: "Beige",
    dimensiones: "160x190cm",
    descripcionLarga:
      "Cama Queen 160x190 con base cama, colchón pillow top firmeza media y 2 almohadas. Envío e instalación incluidos.",
    especificaciones: [
      { clave: "Tamaño", valor: "Queen 160x190" },
      { clave: "Firmeza", valor: "Media" },
    ],
    imageKeywords: ["queen-bed", "bed-frame", "bedroom-set"],
    color: "bg-amber-300",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Closet 4 Puertas",
    marca: "Homecenter",
    modelo: "Modular 160",
    origen: "Colombia",
    costo: 585000,
    precio: 899000,
    stock: 8,
    stockMinimo: 2,
    stockMaximo: 16,
    unidad: "unidad",
    ubicacionFisica: "Showroom M3",
    proveedor: "Sodimac Colombia",
    garantia: "1 año",
    tiempoEntrega: "7 días",
    material: "MDF laminado",
    colorProducto: "Blanco/wengue",
    dimensiones: "160x50x200cm",
    descripcionLarga:
      "Closet 4 puertas batientes + 2 cajones, espejo interior. Barra vestir y 4 entrepaños ajustables.",
    especificaciones: [
      { clave: "Puertas", valor: "4" },
      { clave: "Cajones", valor: "2" },
    ],
    imageKeywords: ["closet", "wardrobe", "bedroom-closet"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Mesa Centro Moderna",
    marca: "Tugó",
    modelo: "Cubic",
    origen: "Colombia",
    costo: 225000,
    precio: 349000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Showroom M1",
    proveedor: "Tugó",
    material: "MDF + vidrio templado",
    colorProducto: "Negro/vidrio",
    dimensiones: "110x60x45cm",
    descripcionLarga:
      "Mesa de centro rectangular con cubierta superior vidrio templado 8mm y base inferior MDF negro mate.",
    especificaciones: [
      { clave: "Material superior", valor: "Vidrio 8mm" },
      { clave: "Dimensiones", valor: "110x60cm" },
    ],
    imageKeywords: ["coffee-table", "modern-table", "living-room-table"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Mesa Noche 2 Cajones",
    marca: "Tugó",
    origen: "Colombia",
    costo: 145000,
    precio: 219000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Showroom M3",
    proveedor: "Tugó",
    material: "MDF laminado",
    colorProducto: "Blanco",
    dimensiones: "45x40x55cm",
    descripcionLarga:
      "Mesa de noche con 2 cajones de fácil deslizamiento. Ideal para lámpara, libro y objetos personales.",
    especificaciones: [
      { clave: "Cajones", valor: "2" },
      { clave: "Color", valor: "Blanco mate" },
    ],
    imageKeywords: ["nightstand", "bedside-table", "bedroom-furniture"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Escritorio Home Office",
    marca: "Ikea",
    modelo: "Bekant 140x60",
    origen: "Polonia",
    costo: 485000,
    precio: 749000,
    stock: 10,
    stockMinimo: 3,
    stockMaximo: 20,
    unidad: "unidad",
    ubicacionFisica: "Showroom M2",
    proveedor: "Ikea Colombia",
    garantia: "10 años",
    material: "Aglomerado + acero",
    colorProducto: "Roble/negro",
    dimensiones: "140x60x75cm",
    descripcionLarga:
      "Escritorio ejecutivo Bekant 140cm con cubierta roble y patas acero. Soporta hasta 50kg. Organizador cables.",
    especificaciones: [
      { clave: "Ancho", valor: "140cm" },
      { clave: "Carga máx", valor: "50kg" },
    ],
    imageKeywords: ["office-desk", "home-office", "writing-desk"],
    color: "bg-amber-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Biblioteca 5 Niveles",
    marca: "Ikea",
    modelo: "Billy",
    origen: "Suecia",
    costo: 325000,
    precio: 499000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "unidad",
    ubicacionFisica: "Showroom M2",
    proveedor: "Ikea Colombia",
    garantia: "10 años",
    material: "Aglomerado + chapa pino",
    colorProducto: "Blanco",
    dimensiones: "80x28x202cm",
    descripcionLarga:
      "Biblioteca Billy icónica de 5 entrepaños ajustables. Ideal para libros, decoración y almacenamiento vertical.",
    especificaciones: [
      { clave: "Entrepaños", valor: "5 ajustables" },
      { clave: "Altura", valor: "202cm" },
    ],
    imageKeywords: ["bookshelf", "billy-bookcase", "library-shelf"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Sillas Comedor x2",
    marca: "Tugó",
    modelo: "Eames Replica",
    origen: "China",
    costo: 285000,
    precio: 439000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "par",
    ubicacionFisica: "Showroom M1",
    proveedor: "Tugó",
    material: "Polipropileno + madera haya",
    colorProducto: "Blanco/madera",
    descripcionLarga:
      "Par de sillas estilo Eames DSW, asiento polipropileno moldeado y patas madera haya natural. Apilables.",
    especificaciones: [
      { clave: "Cantidad", valor: "2 sillas" },
      { clave: "Peso máx", valor: "130kg c/u" },
    ],
    imageKeywords: ["dining-chair", "eames-chair", "modern-chair"],
    color: "bg-white",
    shape: "square",
  }),
];
